// Components
import React, { Component } from "react";
import { Provider } from "mobx-react";
import { Navbar, Nav, NavItem } from "react-bootstrap";

import Core from "Core";
import RootStore from "./Stores";

import LoginPage from "./Pages/LoginPage";

// Css
import "./App.css";
import "./css/vendor/bootstrap.min.css";

const pkg = require("../package.json");

// Stores
const _rootStore = new RootStore();
window.stores = _rootStore;

class App extends Component {
  async onLoginStatusChanged(userId, token) {
    // Store locally
    localStorage["its_my_user"] = userId;
    localStorage["its_my_token"] = token;

    await this.fetchUserData(userId);
    window.location.hash = "#";
  }

  async fetchUserData(userId) {
    // Fetch current user data
    try{

        await _rootStore.data.UsersStore.fetch("/" + userId);
        
        const user = _rootStore.data.UsersStore.findById(userId);
        _rootStore.currentUser.user = user;
        
        if (user) {
            await _rootStore.data.CustomersStore.fetchId(user.CustomerId);
            const customer = _rootStore.data.CustomersStore.findById(user.CustomerId);
            
            _rootStore.currentUser.customer = customer;
            
            this.setState({ currentUserId: user.Id, currentCustomer: customer }); // By changing the state, the component will be rerendered (displaying the login-control or actual content)
        }
    }
    catch(e) {
        this.onLogout();
    }
  }

  componentDidMount() {
    const userId = localStorage["its_my_user"];
    const token = localStorage["its_my_user"];
    if (userId && token ) {
       this.fetchUserData(userId);
    }
  }

  onLogout() {
    localStorage["its_my_token"] = "";
    _rootStore.currentUser.user = null;

    window.location.hash = "#";
    this.setState({ currentUserId: null });
  }

  render() {
    let mainControl = null;
    const user = _rootStore.currentUser.user;

    // User info
    let userInfo = null;
    if (user) userInfo = <NavItem active>{user.Name}</NavItem>;

    let logoutButton = user ? (
      <NavItem href="#" onClick={this.onLogout.bind(this)}>
        Logout
      </NavItem>
    ) : null;

    if (_rootStore.currentUser.loggedIn) {
      mainControl = <Core.Components.CurrentView />;
    } else {
      mainControl = (
        <LoginPage
          user={user}
          onLoginStatusChanged={this.onLoginStatusChanged.bind(this)}
        />
      );
    }

    return (
      <div className="App">
        <Navbar inverse className="fix-navbar">
          <Navbar.Header>
            <Navbar.Brand>i-Theses - License Control Panel</Navbar.Brand>
            <Navbar.Text>v{pkg.version}</Navbar.Text>
            <Navbar.Toggle />
          </Navbar.Header>
          {
            <Nav pullRight>
              {userInfo}
              {logoutButton}
            </Nav>
          }
        </Navbar>

        <div className="container">
          <Provider stores={_rootStore}>{mainControl}</Provider>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js